module.exports = __webpack_public_path__ + "img/1x.25f6b66.jpg";